// portfolioData.js - Datos dinámicos para el portfolio con soporte multiidioma
export const portfolioData = {
  personal: {
    name: "Anthony Marín Bolívar",
    title: {
      es: "Full Stack Developer Web",
      en: "Full Stack Web Developer"
    },
    subtitle: {
      es: "Angular | Spring Boot | Laravel | React | React Native | ASP.NET | Nextjs | Gastbyjs | Django | Drupal",
      en: "Angular | Spring Boot | Laravel | React | React Native | ASP.NET | Nextjs | Gastbyjs | Django | Drupal"
    },
    description: {
      es: "Soy un ingeniero de sistemas con un historial comprobado de entregar proyectos exitosos para clientes en todo el mundo. Tengo experiencia con una variedad de frameworks, incluyendo React, Angular, Node.js, Gatsby.js, Drupal, WordPress y ASP.NET, así como conocimiento de varias otras tecnologías. Tengo un nivel básico-intermedio de inglés.",
      en: "I am a systems engineer with a proven track record of delivering successful projects for clients worldwide. I have experience with a variety of frameworks, including React, Angular, Node.js, Gatsby.js, Drupal, WordPress, and ASP.NET, as well as knowledge of several other technologies. I am proficient in English at the basic-intermediate level."
    },
    location: {
      full: "Cañas, Guanacaste, Costa Rica",
      city: "Cañas",
      state: "Guanacaste",
      country: "Costa Rica"
    },
    email: "anthonymmarinbolivar@gmail.com",
    phone: "+506 8371-4550",
    whatsapp: "https://wa.me/+50683714550",
    availability: {
      es: "Disponible para trabajar",
      en: "Available for work"
    }
  },

  skills: {
    frontend: [
      { name: "Angular", level: "Experto", percentage: 90 },
      { name: "React", level: "Experto", percentage: 90 },
      { name: "HTML5", level: "Experto", percentage: 95 },
      { name: "CSS3", level: "Experto", percentage: 90 },
      { name: "JavaScript", level: "Avanzado", percentage: 85 }
    ],
    backend: [
      { name: "Node.js", level: "Experto", percentage: 90 },
      { name: "Spring Boot", level: "Experto", percentage: 90 },
      { name: "Laravel", level: "Avanzado", percentage: 85 },
      { name: "ASP.NET Core", level: "Avanzado", percentage: 85 },
      { name: "Drupal", level: "Experto", percentage: 90 }
    ],
    cms: [
      { name: "WordPress", level: "Experto", percentage: 90 },
      { name: "Drupal", level: "Experto", percentage: 90 }
    ],
    mobile: [
      { name: "React Native", level: "Intermedio", percentage: 70 }
    ],
    testing: [
      { name: "Cypress", level: "Experto", percentage: 90 },
      { name: "Unit Testing", level: "Intermedio", percentage: 70 }
    ],
    devops: [
      { name: "CI/CD", level: "Avanzado", percentage: 85 },
      { name: "Git/GitHub", level: "Experto", percentage: 95 },
      { name: "Docker", level: "Intermedio", percentage: 70 },
      { name: "AWS", level: "Intermedio", percentage: 65 },
      { name: "DDEV", level: "Avanzado", percentage: 85 },
      { name: "Lando", level: "Avanzado", percentage: 80 },
      { name: "WSL2", level: "Experto", percentage: 90 }
    ],
    hosting: [
      { name: "Pantheon", level: "Experto", percentage: 90 },
      { name: "SiteGround", level: "Avanzado", percentage: 85 },
      { name: "HostGator", level: "Avanzado", percentage: 80 },
      { name: "Namecheap", level: "Avanzado", percentage: 85 }
    ],
    ai: [
      { name: "AI Tools", level: "Avanzado", percentage: 85 },
      { name: "Prompt Engineering", level: "Experto", percentage: 90 },
      { name: "ChatGPT/Claude", level: "Experto", percentage: 95 },
      { name: "GitHub Copilot", level: "Avanzado", percentage: 85 }
    ],
    languages: [
      { name: "Español", level: "Nativo", percentage: 100 },
      { name: "English", level: "Intermedio B1-B2", percentage: 75 }
    ]
  },

  projects: [
    {
      id: 1,
      title: {
        es: "Portafolio Digital",
        en: "Digital Portfolio"
      },
      description: {
        es: "Aplicación de portafolio digital desarrollada con React para mostrar proyectos y habilidades profesionales.",
        en: "Digital portfolio application developed with React to showcase professional projects and skills."
      },
      technologies: ["React", "CSS3", "JavaScript"],
      image: "J0.png",
      link: "#",
      github: "https://github.com/AnthonyDaniel",
      type: {
        es: "Desarrollo Full-Stack",
        en: "Full-Stack Development"
      },
      status: {
        es: "Activo",
        en: "Active"
      }
    },
    {
      id: 2,
      title: {
        es: "Mi Mercadito",
        en: "Mi Mercadito"
      },
      description: {
        es: "Plataforma de e-commerce completa desarrollada con Angular 11 y ASP.NET, con gestión de inventario y sistema de pagos.",
        en: "Complete e-commerce platform developed with Angular 11 and ASP.NET, featuring inventory management and payment system."
      },
      technologies: ["Angular 11", "ASP.NET", "SQL Server"],
      image: "J1.png",
      link: "#",
      github: "#",
      type: {
        es: "E-commerce - Desarrollo Parcial",
        en: "E-commerce - Partial Development"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 3,
      title: {
        es: "UNA Horarios",
        en: "UNA Schedule"
      },
      description: {
        es: "Sistema de gestión de horarios universitarios desarrollado con Angular 8 y Firebase, con sincronización en tiempo real.",
        en: "University schedule management system developed with Angular 8 and Firebase, featuring real-time synchronization."
      },
      technologies: ["Angular 8", "Firebase", "PWA"],
      image: "J2.png",
      link: "https://una-horario.web.app/",
      github: "https://github.com/AnthonyDaniel",
      type: {
        es: "Proyecto Universitario",
        en: "University Project"
      },
      status: {
        es: "Activo",
        en: "Active"
      }
    },
    {
      id: 4,
      title: {
        es: "Schmidt Marine",
        en: "Schmidt Marine"
      },
      description: {
        es: "Sitio web corporativo para instituto de investigación marina desarrollado con WordPress.",
        en: "Corporate website for marine research institute developed with WordPress."
      },
      technologies: ["WordPress", "PHP", "MySQL"],
      image: "J3.png",
      link: "https://www.schmidtmarine.org/",
      github: "#",
      type: {
        es: "Desarrollo Web - Parcial",
        en: "Web Development - Partial"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 5,
      title: {
        es: "Plugin para Admetricks con Google Data Studio",
        en: "Plugin for Admetricks with Google Data Studio"
      },
      description: {
        es: "Plugin desarrollado en JavaScript para integración con Google Data Studio y Admetricks.",
        en: "JavaScript plugin developed for integration with Google Data Studio and Admetricks."
      },
      technologies: ["JavaScript", "Google Data Studio API"],
      image: "J4.png",
      link: "#",
      github: "#",
      type: {
        es: "Desarrollo de Plugin",
        en: "Plugin Development"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 6,
      title: {
        es: "Curso para Walmart",
        en: "Course for Walmart"
      },
      description: {
        es: "Curso interactivo desarrollado con React y Scorm 2.1 para capacitación corporativa de Walmart.",
        en: "Interactive course developed with React and Scorm 2.1 for Walmart corporate training."
      },
      technologies: ["React", "Scorm 2.1"],
      image: "J5.png",
      link: "#",
      github: "#",
      type: {
        es: "Desarrollo Web - Parcial",
        en: "Web Development - Partial"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 7,
      title: {
        es: "Doitxr",
        en: "Doitxr"
      },
      description: {
        es: "Aplicación web desarrollada con Next.js para experiencias de realidad extendida.",
        en: "Web application developed with Next.js for extended reality experiences."
      },
      technologies: ["Next.js", "React", "CSS3"],
      image: "J6.png",
      link: "#",
      github: "#",
      type: {
        es: "Desarrollo Web - Parcial",
        en: "Web Development - Partial"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 8,
      title: {
        es: "Weknow Inc",
        en: "Weknow Inc"
      },
      description: {
        es: "Sitio web corporativo desarrollado con Gatsby.js, GraphQL y Drupal como CMS headless.",
        en: "Corporate website developed with Gatsby.js, GraphQL and Drupal as headless CMS."
      },
      technologies: ["Gatsby.js", "GraphQL", "Drupal"],
      image: "J7.png",
      link: "https://weknowinc.com/",
      github: "#",
      type: {
        es: "Desarrollo Web - Parcial",
        en: "Web Development - Partial"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 9,
      title: {
        es: "Herramienta de Compresión de Imágenes",
        en: "Image Compression Tool"
      },
      description: {
        es: "Herramienta web para compresión de imágenes desarrollada con Vanilla JavaScript y Canvas API.",
        en: "Web tool for image compression developed with Vanilla JavaScript and Canvas API."
      },
      technologies: ["Vanilla JS", "Canvas API", "PWA"],
      image: "J18.png",
      link: "https://comprimir-imagenes-rapido-by-thony.web.app/",
      github: "https://github.com/AnthonyDaniel",
      type: {
        es: "Desarrollo Completo",
        en: "Full Development"
      },
      status: {
        es: "Activo",
        en: "Active"
      }
    },
    {
      id: 10,
      title: {
        es: "Animación Pescando Futuro Próspero",
        en: "Pescando Futuro Próspero Animation"
      },
      description: {
        es: "Sitio web con animaciones desarrollado con WordPress para campaña educativa.",
        en: "Animated website developed with WordPress for educational campaign."
      },
      technologies: ["WordPress", "CSS Animations", "JavaScript"],
      image: "J9.png",
      link: "https://pescandofuturoprospero.com/",
      github: "#",
      type: {
        es: "Desarrollo Web - Parcial",
        en: "Web Development - Partial"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 11,
      title: {
        es: "Soporte",
        en: "Support"
      },
      description: {
        es: "Sistema de soporte técnico desarrollado con WordPress.",
        en: "Technical support system developed with WordPress."
      },
      technologies: ["WordPress", "PHP", "MySQL"],
      image: "J9.png",
      link: "#",
      github: "#",
      type: {
        es: "Desarrollo Web - Parcial",
        en: "Web Development - Partial"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 12,
      title: {
        es: "Schmidt Marine 2020 Annual Report",
        en: "Schmidt Marine 2020 Annual Report"
      },
      description: {
        es: "Reporte anual interactivo 2020 para Schmidt Marine desarrollado con WordPress.",
        en: "Interactive annual report 2020 for Schmidt Marine developed with WordPress."
      },
      technologies: ["WordPress", "CSS3", "JavaScript"],
      image: "J10.png",
      link: "https://2020annualreport.schmidtocean.org/",
      github: "#",
      type: {
        es: "Desarrollo Web - Parcial",
        en: "Web Development - Partial"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 13,
      title: {
        es: "Vida Lab",
        en: "Vida Lab"
      },
      description: {
        es: "Laboratorio virtual desarrollado con React, Firebase y EmailJS.",
        en: "Virtual laboratory developed with React, Firebase and EmailJS."
      },
      technologies: ["React", "Firebase", "EmailJS"],
      image: "J11.png",
      link: "#",
      github: "#",
      type: {
        es: "Desarrollo Completo",
        en: "Full Development"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 14,
      title: {
        es: "ShowTime",
        en: "ShowTime"
      },
      description: {
        es: "Plataforma de entretenimiento desarrollada con React, Node.js y AWS.",
        en: "Entertainment platform developed with React, Node.js and AWS."
      },
      technologies: ["React", "Node.js", "AWS"],
      image: "J12.png",
      link: "#",
      github: "#",
      type: {
        es: "Desarrollo Web - Parcial",
        en: "Web Development - Partial"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 15,
      title: {
        es: "Schmidt Marine 2021 Annual Report",
        en: "Schmidt Marine 2021 Annual Report"
      },
      description: {
        es: "Reporte anual interactivo 2021 para Schmidt Marine desarrollado con WordPress.",
        en: "Interactive annual report 2021 for Schmidt Marine developed with WordPress."
      },
      technologies: ["WordPress", "CSS3", "JavaScript"],
      image: "J13.png",
      link: "https://2021annualreport.schmidtocean.org/",
      github: "#",
      type: {
        es: "Desarrollo Web - Parcial",
        en: "Web Development - Partial"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 16,
      title: {
        es: "Migración ADL (Drupal 8 a Drupal 9)",
        en: "ADL Migration (Drupal 8 to Drupal 9)"
      },
      description: {
        es: "Migración del sitio de la Liga Anti-Difamación de Drupal 8 a Drupal 9.",
        en: "Migration of Anti-Defamation League site from Drupal 8 to Drupal 9."
      },
      technologies: ["Drupal 8", "Drupal 9", "PHP", "MySQL"],
      image: "J14.png",
      link: "https://www.adl.org/",
      github: "#",
      type: {
        es: "Backend - Desarrollo Parcial",
        en: "Backend - Partial Development"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 17,
      title: {
        es: "NOCOE Site",
        en: "NOCOE Site"
      },
      description: {
        es: "Sitio web corporativo desarrollado con Drupal 9 para NOCOE.",
        en: "Corporate website developed with Drupal 9 for NOCOE."
      },
      technologies: ["Drupal 9", "PHP", "MySQL"],
      image: "J15.png",
      link: "https://transportationops.org/",
      github: "#",
      type: {
        es: "Backend - Desarrollo Parcial",
        en: "Backend - Partial Development"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 18,
      title: {
        es: "Saipem Site",
        en: "Saipem Site"
      },
      description: {
        es: "Sitio web corporativo desarrollado con Drupal 9 para Saipem.",
        en: "Corporate website developed with Drupal 9 for Saipem."
      },
      technologies: ["Drupal 9", "PHP", "MySQL"],
      image: "J16.png",
      link: "https://www.saipem.com/",
      github: "#",
      type: {
        es: "Backend - Desarrollo Parcial",
        en: "Backend - Partial Development"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 19,
      title: {
        es: "New Jersey Court Site",
        en: "New Jersey Court Site"
      },
      description: {
        es: "Sitio web oficial de las cortes de New Jersey con migración de Drupal 9 a Drupal 10.",
        en: "Official New Jersey Court website with migration from Drupal 9 to Drupal 10."
      },
      technologies: ["Drupal 9", "Drupal 10", "PHP", "MySQL"],
      image: "J17.png",
      link: "https://www.njcourts.gov/",
      github: "#",
      type: {
        es: "Frontend-Backend - Desarrollo Parcial",
        en: "Frontend-Backend - Partial Development"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 20,
      title: {
        es: "Sistema para Laboratorio Clínico",
        en: "Clinical Laboratory System"
      },
      description: {
        es: "Sistema completo de gestión para laboratorio clínico desarrollado con Laravel 9.",
        en: "Complete management system for clinical laboratory developed with Laravel 9."
      },
      technologies: ["Laravel 9", "PHP", "MySQL", "Bootstrap"],
      image: "J19.png",
      link: "#",
      github: "#",
      type: {
        es: "Desarrollo Completo",
        en: "Full Development"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 21,
      title: {
        es: "Office of Justice Programs",
        en: "Office of Justice Programs"
      },
      description: {
        es: "Sitio web oficial del Departamento de Justicia de EE.UU. desarrollado con Drupal 10.",
        en: "Official U.S. Department of Justice website developed with Drupal 10."
      },
      technologies: ["Drupal 10", "PHP", "MySQL"],
      image: "J20.png",
      link: "https://www.ojp.gov/",
      github: "#",
      type: {
        es: "Frontend-Backend - Desarrollo Parcial",
        en: "Frontend-Backend - Partial Development"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 22,
      title: {
        es: "The Legacy Project",
        en: "The Legacy Project"
      },
      description: {
        es: "Sitio web para proyecto de legado desarrollado con Drupal 10.",
        en: "Legacy project website developed with Drupal 10."
      },
      technologies: ["Drupal 10", "PHP", "MySQL"],
      image: "J21.png",
      link: "https://legacyprojectchicago.org/",
      github: "#",
      type: {
        es: "Frontend-Backend - Desarrollo Parcial",
        en: "Frontend-Backend - Partial Development"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 23,
      title: {
        es: "Riesgos del Trabajo",
        en: "Work Risks"
      },
      description: {
        es: "Sitio web informativo sobre riesgos laborales desarrollado con WordPress.",
        en: "Informational website about work risks developed with WordPress."
      },
      technologies: ["WordPress", "PHP", "MySQL"],
      image: "J22.png",
      link: "https://riesgosdeltrabajo.cr/",
      github: "#",
      type: {
        es: "Mantenimiento General",
        en: "General Maintenance"
      },
      status: {
        es: "Activo",
        en: "Active"
      }
    },
    {
      id: 24,
      title: {
        es: "Permiso Licencia CR",
        en: "Permit License CR"
      },
      description: {
        es: "Portal de permisos y licencias de Costa Rica desarrollado con WordPress.",
        en: "Costa Rica permits and licenses portal developed with WordPress."
      },
      technologies: ["WordPress", "PHP", "MySQL"],
      image: "J23.png",
      link: "https://permisolicencia.cr/",
      github: "#",
      type: {
        es: "Mantenimiento General",
        en: "General Maintenance"
      },
      status: {
        es: "Activo",
        en: "Active"
      }
    },
    {
      id: 25,
      title: {
        es: "Póliza Estudiantil del INS",
        en: "INS Student Insurance"
      },
      description: {
        es: "Portal de seguros estudiantiles del INS desarrollado con WordPress.",
        en: "INS student insurance portal developed with WordPress."
      },
      technologies: ["WordPress", "PHP", "MySQL"],
      image: "J24.png",
      link: "https://polizaestudiantil.cr/",
      github: "#",
      type: {
        es: "Mantenimiento General",
        en: "General Maintenance"
      },
      status: {
        es: "Activo",
        en: "Active"
      }
    },
    {
      id: 26,
      title: {
        es: "Póliza de Construcción",
        en: "Construction Insurance"
      },
      description: {
        es: "Portal de seguros de construcción desarrollado con WordPress.",
        en: "Construction insurance portal developed with WordPress."
      },
      technologies: ["WordPress", "PHP", "MySQL"],
      image: "J25.png",
      link: "https://polizaconstruccion.cr/",
      github: "#",
      type: {
        es: "Mantenimiento General",
        en: "General Maintenance"
      },
      status: {
        es: "Activo",
        en: "Active"
      }
    },
    {
      id: 27,
      title: {
        es: "Whitehorse Maritime Academy",
        en: "Whitehorse Maritime Academy"
      },
      description: {
        es: "Sitio web de academia marítima con ajustes frontend y plugin para carousel.",
        en: "Maritime academy website with frontend adjustments and carousel plugin."
      },
      technologies: ["WordPress", "PHP", "JavaScript", "CSS"],
      image: "J26.png",
      link: "https://whitehorsemaritime.academy/",
      github: "#",
      type: {
        es: "Ajustes Frontend y Plugin",
        en: "Frontend Adjustments and Plugin"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 28,
      title: {
        es: "University of Michigan Health-Sparrow",
        en: "University of Michigan Health-Sparrow"
      },
      description: {
        es: "Sitio web de salud de la Universidad de Michigan con trabajo parcial en Drupal.",
        en: "University of Michigan health website with partial work in Drupal."
      },
      technologies: ["Drupal", "PHP", "MySQL"],
      image: "J27.png",
      link: "https://www.uofmhealthsparrow.org/",
      github: "#",
      type: {
        es: "Trabajo Parcial en el Sitio",
        en: "Partially Work on Site"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 29,
      title: {
        es: "Find a Doctor - University of Michigan Health-Sparrow",
        en: "Find a Doctor - University of Michigan Health-Sparrow"
      },
      description: {
        es: "Motor de búsqueda de doctores desarrollado con React y Yext.",
        en: "Doctor search engine developed with React and Yext."
      },
      technologies: ["React", "Yext", "JavaScript"],
      image: "J28.png",
      link: "https://www.uofmhealthsparrow.org/find-a-doctor",
      github: "#",
      type: {
        es: "Motor de Búsqueda con React y Yext",
        en: "Search Engine with React and Yext"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 30,
      title: {
        es: "Impact Report 2023 - Schmidt Ocean Institute",
        en: "Impact Report 2023 - Schmidt Ocean Institute"
      },
      description: {
        es: "Reporte de impacto 2023 para Schmidt Ocean Institute desarrollado con React.",
        en: "Impact report 2023 for Schmidt Ocean Institute developed with React."
      },
      technologies: ["React", "JavaScript", "CSS3"],
      image: "J29.png",
      link: "https://2023annualreport.schmidtocean.org/",
      github: "#",
      type: {
        es: "Desarrollador Asistente",
        en: "Assistant Developer"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 31,
      title: {
        es: "First Industrial Realty Trust",
        en: "First Industrial Realty Trust"
      },
      description: {
        es: "Migración de sitio web de Drupal 9 a Drupal 10 para First Industrial.",
        en: "Website migration from Drupal 9 to Drupal 10 for First Industrial."
      },
      technologies: ["Drupal 9", "Drupal 10", "PHP", "MySQL"],
      image: "J30.png",
      link: "https://www.firstindustrial.com/",
      github: "#",
      type: {
        es: "Migración de Drupal 9 a Drupal 10",
        en: "Migration from Drupal 9 to Drupal 10"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 32,
      title: {
        es: "Sjogrens",
        en: "Sjogrens"
      },
      description: {
        es: "Desarrollo asistente en sitio web de Sjogrens con Drupal.",
        en: "Assistant development on Sjogrens website with Drupal."
      },
      technologies: ["Drupal", "PHP", "MySQL"],
      image: "J31.png",
      link: "https://sjogrens.org/",
      github: "#",
      type: {
        es: "Desarrollador Asistente en Sjogrens",
        en: "Assistant Developer at Sjogrens"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 33,
      title: {
        es: "Sardimar CR",
        en: "Sardimar CR"
      },
      description: {
        es: "Colaboración parcial como desarrollador secundario en sitio de Sardimar.",
        en: "Partial collaboration as secondary developer on Sardimar site."
      },
      technologies: ["WordPress", "PHP", "MySQL"],
      image: "J32.png",
      link: "#",
      github: "#",
      type: {
        es: "Colaboración Parcial (Desarrollador Secundario)",
        en: "Partial Collaboration (Secondary Developer)"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 34,
      title: {
        es: "Northbrook Public Library",
        en: "Northbrook Public Library"
      },
      description: {
        es: "Mantenimiento, actualización de tema base y ajustes parciales en diferentes módulos de Drupal.",
        en: "Maintenance, base theme update and partial adjustments in different Drupal modules."
      },
      technologies: ["Drupal", "PHP", "MySQL", "CSS"],
      image: "J33.png",
      link: "https://northbrook.info/",
      github: "#",
      type: {
        es: "Mantenimiento y Actualización de Tema Base",
        en: "Maintenance and Base Theme Update"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    },
    {
      id: 35,
      title: {
        es: "Agú CR",
        en: "Agú CR"
      },
      description: {
        es: "Ajustes menores como desarrollador asistente en sitio de Agú CR.",
        en: "Minor adjustments as assistant developer on Agú CR site."
      },
      technologies: ["WordPress", "PHP", "CSS"],
      image: "J34.png",
      link: "#",
      github: "#",
      type: {
        es: "Ajustes Menores (Desarrollador Asistente)",
        en: "Minor Adjustments (Assistant Developer)"
      },
      status: {
        es: "Completado",
        en: "Completed"
      }
    }
  ],

  experience: [
    {
      type: "trabajo",
      position: {
        es: "Desarrollador Drupal",
        en: "Drupal Developer"
      },
      company: "Bright Plum, Inc.",
      startDate: "2022-09-01",
      endDate: "Presente",
      location: {
        es: "Estados Unidos (Remoto)",
        en: "United States (Remote)"
      },
      description: {
        es: "Empresa especializada en soporte certificado de Drupal. Desarrollo especializado en Drupal para clientes enterprise con enfoque en rendimiento y seguridad.",
        en: "A white-glove, certified Drupal support shop. Specialized Drupal development for enterprise clients with focus on performance and security."
      },
      technologies: ["Drupal", "PHP", "Git", "JavaScript", "MySQL"],
      achievements: [
        {
          es: "Desarrollo especializado en Drupal para clientes enterprise",
          en: "Specialized Drupal development for enterprise clients"
        },
        {
          es: "Soporte certificado y desarrollo de módulos custom",
          en: "Certified support and custom module development"
        },
        {
          es: "Trabajo remoto con clientes internacionales",
          en: "Remote work with international clients"
        },
        {
          es: "Optimización de rendimiento y seguridad",
          en: "Performance and security optimization"
        }
      ]
    },
    {
      type: "trabajo",
      position: {
        es: "Desarrollador Full Stack Web",
        en: "Full Stack Web Developer"
      },
      company: "Décimo Technology Solutions",
      startDate: "2021-01-01",
      endDate: "Presente",
      location: {
        es: "Costa Rica (Remoto)",
        en: "Costa Rica (Remote)"
      },
      description: {
        es: "Desarrollo full-stack web con enfoque en frameworks modernos y soluciones empresariales. Liderando múltiples proyectos y mentoreando desarrolladores junior.",
        en: "Full-stack web development with focus on modern frameworks and enterprise solutions. Leading multiple projects and mentoring junior developers."
      },
      technologies: ["Git", "WordPress", "React", "Angular", "Laravel", "ASP.NET", "Drupal", "Node.js"],
      achievements: [
        {
          es: "Lideré el desarrollo de 30+ proyectos web",
          en: "Led development of 30+ web projects"
        },
        {
          es: "Especialización en desarrollo full-stack",
          en: "Specialization in full-stack development"
        },
        {
          es: "Migración de múltiples sitios entre versiones",
          en: "Migration of multiple sites between versions"
        },
        {
          es: "Desarrollo de sistemas enterprise y e-commerce",
          en: "Enterprise systems and e-commerce development"
        }
      ]
    },
    {
      type: "trabajo",
      position: {
        es: "Desarrollador Angular y ASP.NET",
        en: "Angular and ASP.NET Developer"
      },
      company: "Décimo Technology Solutions",
      startDate: "2020-01-01",
      endDate: "2020-12-31",
      location: "Liberia, Guanacaste, Costa Rica",
      description: {
        es: "Desarrollo especializado en frameworks Angular y ASP.NET para aplicaciones web y soluciones empresariales.",
        en: "Specialized development in Angular and ASP.NET frameworks for web applications and enterprise solutions."
      },
      technologies: ["TypeScript", "C#", "Angular", "ASP.NET"],
      achievements: [
        {
          es: "Desarrollo especializado en Angular y ASP.NET",
          en: "Specialized development in Angular and ASP.NET"
        },
        {
          es: "Creación de aplicaciones web empresariales",
          en: "Creation of enterprise web applications"
        },
        {
          es: "Implementación de arquitecturas escalables",
          en: "Implementation of scalable architectures"
        }
      ]
    },
    {
      type: "trabajo",
      position: {
        es: "Desarrollador Unity (Practicante)",
        en: "Unity Developer (Intern)"
      },
      company: "Décimo Technology Solutions",
      startDate: "2019-08-01",
      endDate: "2019-12-31",
      location: "Liberia, Guanacaste, Costa Rica",
      description: {
        es: "Práctica profesional enfocada en desarrollo de juegos con Unity y aplicaciones interactivas usando el lenguaje de programación C#.",
        en: "Internship focused on Unity game development and interactive applications using C# programming language."
      },
      technologies: ["Unity", "C#", "Game Development"],
      achievements: [
        {
          es: "Desarrollé aplicaciones interactivas con Unity",
          en: "Developed interactive applications with Unity"
        },
        {
          es: "Implementé mecánicas de juego complejas",
          en: "Implemented complex game mechanics"
        },
        {
          es: "Experiencia en desarrollo con Unity Engine y C#",
          en: "Experience in Unity Engine and C# development"
        }
      ]
    }
  ],

  education: [
    {
      id: 1,
      institution: "Universidad Nacional de Costa Rica",
      degree: {
        es: "Ingeniería en Sistemas de Información",
        en: "Information Systems Engineering"
      },
      period: "2017 - 2020",
      status: {
        es: "Graduado",
        en: "Graduated"
      },
      description: {
        es: "Ingeniería en sistemas de información con enfoque en desarrollo de software, bases de datos y arquitectura de sistemas.",
        en: "Engineering in information systems with focus on software development, databases and system architecture."
      }
    },
    {
      id: 2,
      institution: "American English for Business",
      degree: {
        es: "Inglés Empresarial Americano",
        en: "American English for Business"
      },
      period: {
        es: "Feb 2025 - Oct 2025",
        en: "Feb 2025 - Oct 2025"
      },
      status: {
        es: "En curso",
        en: "In progress"
      },
      description: {
        es: "Programa de inglés empresarial enfocado en comunicación profesional y habilidades de negocio en inglés como lengua extranjera.",
        en: "Business English program focused on professional communication and business skills in English as a foreign language."
      }
    },
    {
      id: 3,
      institution: "Centro Cultural Costarricense Norteamericano",
      degree: {
        es: "Inglés Conversacional",
        en: "Conversational English"
      },
      period: "2021 - 2022",
      status: {
        es: "Completado",
        en: "Completed"
      },
      description: {
        es: "Programa intensivo de inglés conversacional para mejorar habilidades de comunicación técnica.",
        en: "Intensive conversational English program to improve technical communication skills."
      }
    },
    {
      id: 4,
      institution: "Liceo Miguel Araya Venegas",
      degree: {
        es: "Certificado Avanzado en Microsoft Office",
        en: "Advanced Microsoft Office Certificate"
      },
      period: "2016",
      status: {
        es: "Completado",
        en: "Completed"
      },
      description: {
        es: "Certificado de 300 horas en aplicaciones avanzadas de Microsoft Office y herramientas de productividad.",
        en: "300-hour certificate in advanced microsoft office applications and productivity tools."
      }
    }
  ],

  socialLinks: [
    {
      name: "GitHub",
      url: "https://github.com/AnthonyDaniel",
      icon: "💻"
    },
    {
      name: "LinkedIn", 
      url: "https://www.linkedin.com/in/thony1199/",
      icon: "💼"
    },
    {
      name: "Facebook",
      url: "https://www.facebook.com/thony1199/",
      icon: "📘"
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/thonny1199/",
      icon: "�"
    },
    {
      name: "Portfolio",
      url: "https://soy-thony.web.app/",
      icon: "🌐"
    }
  ],

  services: [
    {
      name: {
        es: "Desarrollo Web Frontend",
        en: "Frontend Web Development"
      },
      description: {
        es: "Interfaces de usuario modernas y responsivas con las últimas tecnologías.",
        en: "Modern and responsive user interfaces with the latest technologies."
      },
      price: {
        es: "Desde $500",
        en: "From $500"
      },
      features: [
        {
          es: "Diseño responsive y mobile-first",
          en: "Responsive and mobile-first design"
        },
        {
          es: "Optimización de velocidad de carga",
          en: "Loading speed optimization"
        },
        {
          es: "Integración con APIs",
          en: "API integration"
        },
        {
          es: "SEO optimizado",
          en: "SEO optimized"
        },
        {
          es: "Compatibilidad entre navegadores",
          en: "Cross-browser compatibility"
        }
      ],
      technologies: ["React", "Vue.js", "HTML5", "CSS3", "JavaScript"],
      deliveryTime: {
        es: "2-4 semanas",
        en: "2-4 weeks"
      }
    },
    {
      name: {
        es: "Desarrollo Web Backend",
        en: "Backend Web Development"
      },
      description: {
        es: "Arquitecturas robustas y escalables para aplicaciones web complejas.",
        en: "Robust and scalable architectures for complex web applications."
      },
      price: {
        es: "Desde $800",
        en: "From $800"
      },
      features: [
        {
          es: "APIs RESTful y GraphQL",
          en: "RESTful and GraphQL APIs"
        },
        {
          es: "Autenticación y autorización",
          en: "Authentication and authorization"
        },
        {
          es: "Integración con bases de datos",
          en: "Database integration"
        },
        {
          es: "Deployment y DevOps",
          en: "Deployment and DevOps"
        },
        {
          es: "Documentación técnica",
          en: "Technical documentation"
        }
      ],
      technologies: ["Node.js", "Laravel", "Express", "MongoDB", "MySQL"],
      deliveryTime: {
        es: "3-6 semanas",
        en: "3-6 weeks"
      }
    },
    {
      name: {
        es: "Aplicaciones Full-Stack",
        en: "Full-Stack Applications"
      },
      description: {
        es: "Soluciones completas de frontend y backend integradas.",
        en: "Complete integrated frontend and backend solutions."
      },
      price: {
        es: "Desde $1200",
        en: "From $1200"
      },
      features: [
        {
          es: "Aplicación web completa",
          en: "Complete web application"
        },
        {
          es: "Panel de administración",
          en: "Administration panel"
        },
        {
          es: "Sistema de usuarios",
          en: "User system"
        },
        {
          es: "Integración de pagos",
          en: "Payment integration"
        },
        {
          es: "Soporte técnico incluido",
          en: "Technical support included"
        }
      ],
      technologies: ["React", "Node.js", "MongoDB", "Express", "JWT"],
      deliveryTime: {
        es: "4-8 semanas",
        en: "4-8 weeks"
      }
    }
  ],

  social: [
    {
      platform: "GitHub",
      url: "https://github.com/AnthonyDaniel",
      icon: "💻"
    },
    {
      platform: "LinkedIn", 
      url: "https://www.linkedin.com/in/thony1199/",
      icon: "💼"
    },
    {
      platform: "Email",
      url: "mailto:anthonymmarinbolivar@gmail.com",
      icon: "📧"
    },
    {
      platform: "WhatsApp",
      url: "https://wa.me/+50683714550",
      icon: "💬"
    }
  ],

  contactMethods: [
    {
      name: "Email",
      value: "anthonymmarinbolivar@gmail.com",
      icon: "📧",
      link: "mailto:anthonymmarinbolivar@gmail.com"
    },
    {
      name: "WhatsApp",
      value: "+506 8371-4550",
      icon: "💬",
      link: "https://wa.me/+50683714550"
    },
    {
      name: "LinkedIn",
      value: "Anthony Marín Bolívar",
      icon: "💼",
      link: "https://www.linkedin.com/in/thony1199/"
    },
    {
      name: "Ubicación",
      value: "Cañas, Guanacaste, Costa Rica",
      icon: "📍",
      link: "#"
    }
  ],
};

// Helper function para obtener texto según el idioma actual
export const getPortfolioText = (textObj, currentLanguage = 'es') => {
  if (typeof textObj === 'string') return textObj;
  if (typeof textObj === 'object' && textObj !== null) {
    return textObj[currentLanguage] || textObj.es || textObj.en || '';
  }
  return '';
};

// Alias para compatibilidad
export const appData = portfolioData;

export default portfolioData;
